import React, { memo, useCallback, useContext } from 'react';

import { NotificationContent } from './NotificationContent/NotificationContent';
import { SidebarBase } from '../SidebarBase/SidebarBase';
import { SidebarContext } from '../PageLayout/ContextProvider';

export const NotificationSidebar = memo(({ navigationBarVisibility }) => {
    const { sidebarVisibility: { notificationSidebarVisibility: visibility = false } = {}, handleCloseSidebar } =
        useContext(SidebarContext);

    const handleClose = useCallback(() => handleCloseSidebar(), []);

    return (
        <SidebarBase visibility={visibility} handleClose={handleClose} anchor="right" navigationBarVisibility={navigationBarVisibility}>
            <NotificationContent />
        </SidebarBase>
    );
});

NotificationContent.displayName = 'NotificationSidebar';
